import { Route, Switch } from "react-router-dom";

import SlateSiteBannerPage from "../../workspace/ag/slate-site-banner";

export const slug = "ag";

export function ArtyomGabtraupovRoutes() {
  return (
    <Switch>
      <Route path="/ag/slate-site-banner" component={SlateSiteBannerPage} />
    </Switch>
  );
}
